
// import {Toast} from 'vant'
import { ref, reactive,ComponentInternalInstance,getCurrentInstance,watch } from 'vue'
import { useRoute } from 'vue-router'
export default {
  props:{
     isEmail:{
       type:Boolean,
       default:false
     },
     CaptchaType:{
       type:String,
       default:'2'
     },
     Toast:{
      type:Object,
      required: true,
      default:()=>{
          return {}
      }
    }
  },
  setup(props:any){     
    const showPopover = ref(false);
    const verify = reactive({
       code:'',
       email:'',
       phone:''
    })
     const actions = [
      { text: '254' },
      { text: '234' },
      { text: '256' },
    ];
    
    // const isEmail = ref(false)
    // 区号选择
    let country_code =  ref(actions[0].text)
    
    let isPhoneHint = ref(false)
    const verifyPhone = ():boolean =>{
      return  isPhoneHint.value = !verify.phone&&!/^([1-9]{1}[0-9]{8}|[1-9]{1}[0-9]{9})$/.test(verify.phone)
    }
    let isEmailHint = ref(false)
    // 邮箱正则  
    const verifyEmail = ():boolean =>{
     return isEmailHint.value = !/^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/.test(verify.email)
    }
     watch(verify, (state) => { 
       if(state.phone == '') {
        isPhoneHint.value = false
       }
       
    });
    let suffix_email = ref(false)
    let emailArr = reactive({list:[
        '@gmail.com',
        '@yahoo.com',
        '@hotmail.com',
        '@outlook.com',
        '@ymail.com',
        '@icloud.com',
        '@live.com',
      ]})
    const editEmailFn = () => {
      // && /^\w+(?=@)/.test(verify.email)
      if(verify.email) {
      suffix_email.value = true
      if(verify.email.includes('@')) {
          suffix_email.value = false
        }
        let arr:any = ['@gmail.com',
        '@yahoo.com',
        '@hotmail.com',
        '@outlook.com',
        '@ymail.com',
        '@icloud.com',
        '@live.com',]
         arr.forEach((item:any,i:any) => {
           if(/^\w+(?=@)/.test(verify.email)){
             emailArr.list[i] =  verify.email.substring(verify.email.indexOf('@'),-1) + item
           }else {
             emailArr.list[i] = verify.email + item
           }
         })
       }else {
          suffix_email.value = false
       }
    }
    //外层关闭
    document.addEventListener("click", (e: any) => {
      var currentCli = document.querySelector(".position_ab_box");
      if (currentCli) {
        if (!currentCli.contains(e.target)) {
          //点击到了id为sellineName以外的区域，隐藏下拉框
          suffix_email.value = false;
        }
      }
    });
    const getEmailNumFn = (name:any) => {
      verify.email = name
      verifyEmail()
      suffix_email.value = false
    }
   interface selectObj {
     text:string
   }
   const onSelect = (action:selectObj) => {
      country_code.value = action.text
    };
    // 获取验证码
    const {proxy}:any = getCurrentInstance() as ComponentInternalInstance                 
    const route = useRoute()

    
    interface userInfo {
      phone: string,
      email: string,
      country_code?: string,
      type: any
    }
    let param = reactive<userInfo>({
      phone:'',
      email:'',
      type:props.CaptchaType,
      country_code:''
    })
    // 验证码60秒等待
    let  waiting = ref(0) 
    const timer = ( ) => {
        waiting.value--
        if (waiting.value > 0 ) setTimeout(() => {timer() }, 1000)
        }
        let count = ref(0)
   let getCaptcha = async () =>{
     if(props.isEmail) {
      if (waiting.value > 0) return             
         if (verifyEmail()) return  props.Toast('Please input a valid email address.');
          param.email = verify.email;
         delete param.country_code
        }else{
      if (waiting.value > 0) return 
        if (verifyPhone()) return props.Toast('Please input valid phone number.');
        param.country_code = country_code.value
        param.phone = verify.phone;
    }
      let res =  await proxy.$http.captcha(param)
      if (res.code == 200) { 
        count.value++
          waiting.value = 60;
          timer()
      }
      else if (res.code == 410)  props.Toast({
            duration: 4000, // 持续展示 props.toast
            message: 'Wrong phone format'})
      else  props.Toast({
            duration: 4000, // 持续展示 props.toast
            message: res.message})
          }
       
          
        
    return {
      verify, 
      verifyPhone,
      verifyEmail,
      isEmailHint,
      isPhoneHint,
      waiting,
      getCaptcha,
      country_code,
      actions,
      showPopover, 
      onSelect,
      count,
      emailArr,
      editEmailFn,
      getEmailNumFn,
      suffix_email

    }
  }
}
